import { request } from "utils/request"
import { createMap, addToMap, replaceInMap, removeFromMap, asyncAction } from "./common"

const initialState = {
  activeAnalysisGroupId: null,
  groups: {},
  bundles: {},
  tasks: {},
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case "analysisGroups/fetch":
      return {...state, groups: createMap(action.res)}
    case "analysisGroups/create":
      const newState = {...state, activeAnalysisGroupId: action.res.id}
      return  {...newState, groups: addToMap(newState.groups, action.res)}
    case "analysisGroups/edit": {
      const editedGroup = action.res
      const groupId = editedGroup?.id
      const selectedTasks = editedGroup?.selectedTasks
      const updatedGroups = replaceInMap(state.groups, editedGroup)

      if (!groupId || !Array.isArray(selectedTasks)) {
        return {...state, groups: updatedGroups}
      }

      const existingGroupBundles = state.bundles[groupId] || {}
      const syncedGroupBundles = {}

      selectedTasks.forEach((bundle, index) => {
        if (!bundle?.id) return

        const existingBundle = existingGroupBundles[bundle.id] || {}
        syncedGroupBundles[bundle.id] = {
          ...existingBundle,
          ...bundle,
          id: bundle.id,
          analysisGroupId: existingBundle.analysisGroupId || groupId,
          index: existingBundle.index ?? index,
          cdmo: Boolean(bundle.cdmo),
        }
      })

      return {
        ...state,
        groups: updatedGroups,
        bundles: {
          ...state.bundles,
          [groupId]: syncedGroupBundles,
        }
      }
    }
    case "analysisGroups/remove":
      const tmpState = (state.activeAnalysisGroupId === action.res.id ? {...state, activeAnalysisGroupId: null} : state)
      return {...tmpState, groups: removeFromMap(state.groups, action.res)}
    case "analysisGroups/changeActiveAnalysisGroupId":
      return {...state, activeAnalysisGroupId: action.id}
    case "analysisGroups/fetchBundles":
      return {
        ...state,
        bundles: {
          [action.res.groupId]: {
            ...createMap(action.res.items),
          }
        }
      }
    case "analysisGroups/fetchTasks":
      return {...state, tasks: createMap(action.res)}
    case "analysisGroups/addBundle": {
      const groupId = action.analysisGroupId;
      const bundleId = action.bundleId
      const index = action.index
      const groupBundles = state.bundles[groupId] || {};

      return {
        ...state,
        bundles: {
          ...state.bundles,
          [groupId]: addToMap(groupBundles, { id: bundleId, index: index, analysisGroupId: groupId, cdmo: false  })
        }
      }
    }
    case "analysisGroups/removeBundle": {
      const groupId = action.analysisGroupId;
      const bundleId = action.bundleId;
      const groupBundles = state.bundles[groupId] || {};

      return {
        ...state,
        bundles: {
          ...state.bundles,
          [groupId]: removeFromMap(groupBundles, { id: bundleId })
        }
      }
    }
    case "auth/logout":
      return initialState
    default:
      return state
  }
}

export const fetch = asyncAction("analysisGroups/fetch", (dispatch) => {
  return request("GET", "/analysis-groups").then((res) => res.items)
})

export const remove = asyncAction("analysisGroups/remove", (dispatch, id) => {
  return request("DELETE", `/analysis-group/${id}`).then(() => ({ id }))
})

export const create = asyncAction("analysisGroups/create", (dispatch, input) => {
  return request("POST", `/analysis-groups`, { input }).then((res) => res.group)
})

export const edit = asyncAction("analysisGroups/edit", (dispatch, id, patch) => {
  return request("PATCH", `/analysis-group/${id}`, { patch }).then((res) => res.group)
})

export function changeActiveAnalysisGroupId(id) {
  return { type: "analysisGroups/changeActiveAnalysisGroupId", id }
}

export const fetchTasks = asyncAction("analysisGroups/fetchTasks", (dispatch, groupId) => {
  return request("GET", `/analysis-task-bundle/tasks/${groupId}`).then((res) => res.items)
})

export const fetchBundles = asyncAction(
  "analysisGroups/fetchBundles", (dispatch, groupId) => {
    return request("GET", `/analysis-task-bundle/get-all/${groupId}`).then((res) => {
      return {
        groupId,
        items: res.items,
      };
    });
  }
);

export const addBundle = (analysisGroupId, bundleId, index) => ({
  type: "analysisGroups/addBundle",
  analysisGroupId,
  bundleId,
  index
})

export const removeBundle = (analysisGroupId, bundleId) => ({
  type: "analysisGroups/removeBundle",
  analysisGroupId,
  bundleId,
})